export default "__VITE_ASSET__CIrYX5lT__"